import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useParams } from "react-router-dom";
import Skeleton from "react-loading-skeleton";
import 'react-loading-skeleton/dist/skeleton.css';
import '../product/style/categoryList.css';
import Breadcrumb from '../../Component/breadcrumb/Breadcrumb';
import SearchFilter from  "../../Component/search/Searchlist"
import MobileFilter from '../../Component/Layout/MobileFilter/MobileFilter';
import ProductShorting from '../../Component/Common/ProductShorting';
import SearchMobile from '../../Component/search/SearchMobile';
import { getProductUrl } from "../../utils/url.utils";
import {fetchProductList} from "./redux/ProductList.slice";
import { motion } from "framer-motion";

export const ProducListSecand = () => {
   const dispatch = useDispatch();
  const { slug } = useParams();
  const { products, loading } = useSelector((state) => state.product);
  useEffect(() => {
    if (slug) {
      dispatch(fetchProductList(slug));
    }
  }, [dispatch, slug]);
  console.log("Slug :", slug);
  
  return (
    <>

    <Breadcrumb/>

    <div className="productlist-header serachsectionlisting">
      <div className="container mb-1">
          <div className="row">
            <div className="col col-md-6">
                <p>
                    Showing {products.length} items
                </p>
            </div>

             <div className="col col-md-6">
                   <div className='d-flex' style={{ justifyContent: "flex-end" }} >  
                      <SearchMobile/>
                      <ProductShorting/>
                      <div className="FILTERMOBILE w-00M">
                        <MobileFilter />
                      </div> 
                  </div>
             </div>
          </div> 
       </div>
    </div>

      <section className="category-List">
        <div className="container">
          <div className="row">
            <div className="col-lg-12 col-md-12 col-sm-6 col-12">
            <div className='Bardcom-Desktop-filter'> 
              <div className="row">
                <div className="col-md-2 col-12 w-Widths">
                  <div style={{ display: "flex", flexDirection: "row-reverse", justifyContent: "space-between" }}>  
                  <div className="FILTER-MOBILE">
                    <MobileFilter />
                   </div> 
                   <p style={{ textAlign: 'left', color: 'rgb(127 127 127)', marginBottom: "0", marginTop: "2px" }}>
                      Showing {products.length} items
                    </p>
                  </div>
                </div>
                <div className="col-md-7 col-7 M-Right">
                     <SearchFilter />
                </div>
                <div className="col-md-3 col-5">
                 <div className='d-flex' style={{ justifyContent: "flex-end" }} >  
                      <ProductShorting/>
                      <MobileFilter />
                  </div>
                </div>
              </div>
            </div>
              
              <div className='row'> 
                   {/* {loading
                  ? Array.from({ length: 8 }).map((_, index) => (
                      <div key={index} className="col-lg-3 col-md-4 col-sm-6 col-6">
                        <Skeleton height={200} />
                        <Skeleton width={`80%`} />
                      </div>
                    ))
                  : products.map((product) => (
                      <div key={product.id} className="col-lg-3 col-md-4 col-sm-6 col-6">
                       <div className="border-0 p-0 mt-1">
                          <div className="relative overflow-hidden mb-1">
                          <Link to={getProductUrl(product.qualityNameSlug)} className="block">
                            <img
                              src={product.imagePath}
                              alt={product.qualityName}
                              className="w-100 h-100 object-cover transition duration-300 ease-in-out hover:scale-110 border-radius-10"
                              style={{ borderRadius: "0px" }}
                              loading="lazy"
                            />
                          </Link>
                          </div>

                          <div className="text-center mt-1" style={{ backgroundColor: "rgb(242 242 242)", borderRadius:"3px" }}>
                            <Link
                                to={getProductUrl(product.qualityNameSlug)}
                                className="text-gray-600 text-lg text-decoration-none"
                                style={{ lineHeight: "0" }}
                               >
                                {product.qualityName}
                            </Link>
                          </div>
                        </div>
                      </div>
                    ))} */}

                {loading
                      ? Array.from({ length: 8 }).map((_, index) => (
                          <div key={index} className="col-lg-3 col-md-4 col-sm-6 col-6">
                            <Skeleton height={200} />
                            <Skeleton width="80%" />
                          </div>
                        ))
                      : products.map((product, index) => (
                          <motion.div
                            key={product.id}
                            className="col-lg-3 col-md-4 col-sm-6 col-6"
                            initial={{
                              opacity: 0,
                              y: 30
                            }}
                            animate={{
                              opacity: 1,
                              y: 0
                            }}
                            transition={{
                              duration: 0.4,
                              delay: index * 0.05,
                              ease: "easeOut"
                            }}
                          >
                            <div className="border-0 p-0 mt-1 product-card">
                              <div className="relative overflow-hidden mb-1">
                                <Link  to={getProductUrl(product.qualityNameSlug)} >
                                  <img
                                    src={product.imagePath}
                                    alt={product.qualityName}
                                    className="product-image"
                                    loading="lazy"
                                  />
                                </Link>
                              </div>

                              <div className="text-center mt-1" style={{ backgroundColor: "rgb(242 242 242)", borderRadius:"3px" }}>
                                <Link
                                    to={getProductUrl(product.qualityNameSlug)}
                                    className="text-gray-600 text-lg text-decoration-none"
                                    style={{ lineHeight: "0" }}
                                    >
                                    {product.qualityName}
                                </Link>
                              </div>
                            </div>
                          </motion.div>
                          ))}
                </div>
             </div>
          </div>
        </div>
      </section>
    </>
  );
};
